export default "<p>delete-notecriterias works!</p>\n"